import React, { useState } from "react"

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/plp/plp.module.scss"


const SeoDescription = ({ title, description }) => {
  const [descOpen, setDescOpen] = useState(false);

  return (
    <div className={styles.cdesc} aria-hidden="true">
      <div className={styles.cdesc_content}>
        <div className={styles.cdesc_subtitle}>
          {title}
        </div>
        <h2 className={styles.cdesc_title}>
          About the Collection
          <button 
            type="button"
            className={`${aria_btn} ${styles.circ_plus} btn-circ_plus`} 
            aria-label="Show collection description" 
            aria-expanded={descOpen ? 'true' : 'false'}
            onClick={(e) => setDescOpen(!descOpen) }
          ></button>
        </h2>
        <div 
          className={styles.cdesc_copy} 
          aria-hidden={descOpen ? 'false' : 'true'}
          role="region" dangerouslySetInnerHTML={{ __html: description}} 
        />
      </div>
    </div>
  )
}

export default SeoDescription





